import { translationsHelper } from './TranslationsHelper';
import axios from 'axios';
import {envConfig} from '../configuration/Configuration';
import { logger } from './LoggerHelper';
import { TranslationKeys } from '../configuration/IConfiguration';

interface IMeetingsApiCreateJoinLinkResponse 
{
    joinLink: string;
}

export interface IJoinLinkRetrievalResult
{
    IsSuccess: boolean;
    JoinLink?: string;
    ErrorMessage?: string;
}

class JoinLinkRetriever {

    private _wait = (ms: number) => new Promise(res => setTimeout(res, ms));

    public async getJoinLinkForSkypeUser(skypeToken: string) : Promise<IJoinLinkRetrievalResult> {

        if (envConfig.Environment === "local") {
            await this._wait(1500);
            return {
                IsSuccess: true,
                JoinLink: "https://join.skype.com/cmqqZ0csv0YF",
                    };
            };

        const url = envConfig.UrlMeetingsApi + '/v1/meetnow/createjoinlink';
        try
        {
            logger.Log("generating joinlink for skype user");
            const response = await axios.post<IMeetingsApiCreateJoinLinkResponse>(url, { SkypeToken: skypeToken, Title: translationsHelper.GetTranslation(TranslationKeys.meet_now_conversation_title) });
            if (response.status === 200 && response.data) {
                logger.JoinLinkGenerationSucceeded({ IsGuest: false});
                return { IsSuccess: true, JoinLink: response.data.joinLink };
            }
            logger.JoinLinkGenerationFailed({
                IsGuest: false,
                StatusCode: response.status,
                Error: response.data
            });
            return { IsSuccess: false, ErrorMessage: translationsHelper.GetTranslation(TranslationKeys.error_generating_link_generic) };
        }
        catch (error)
        {
            logger.Log("got error generating joinlink for Skype user", error);
            logger.JoinLinkGenerationFailed({
                IsGuest: false,
                StatusCode: 0,
                Error: error
            });
            return { IsSuccess: false, ErrorMessage: translationsHelper.GetTranslation(TranslationKeys.error_generating_link_generic) };
        }
    }

    public async getJoinLinkForGuestUser() : Promise<IJoinLinkRetrievalResult> {

        if (envConfig.Environment === "local") {
            await this._wait(1500);
            return {
                IsSuccess: true,
                JoinLink: "https://join.skype.com/cmqqZ0csv0YF",
                    };
            };

        const url = envConfig.UrlMeetingsApi + '/v1/meetnow/createjoinlinkguest';
        try
        {
            logger.Log("generating joinlink for guest user");
            const response = await axios.post<IMeetingsApiCreateJoinLinkResponse>(url, { Title: translationsHelper.GetTranslation(TranslationKeys.meet_now_conversation_title) });
            if (response.status === 200 && response.data) {
                logger.JoinLinkGenerationSucceeded({ IsGuest: true});
                return { IsSuccess: true, JoinLink: response.data.joinLink };
            }
            logger.JoinLinkGenerationFailed({
                IsGuest: true,
                StatusCode: response.status,
                Error: response.data
            });
            return { IsSuccess: false, ErrorMessage: translationsHelper.GetTranslation(TranslationKeys.error_generating_link_generic) };
        }
        catch (error)
        {
            logger.Log("got error generating joinlink for guest user", error);
            logger.JoinLinkGenerationFailed({
                IsGuest: true,
                StatusCode: 0,
                Error: error
            });
            return { IsSuccess: false, ErrorMessage: translationsHelper.GetTranslation(TranslationKeys.error_generating_link_generic) };
        }
    }
}

export const joinLinkRetriever = new JoinLinkRetriever();